/* ==========================================================================
   <image-text-split> — media/video controller for the Image & Text Split section.
   - silent autoplay on loop with an image poster/fallback
   - optional play/pause control per video
   - respects prefers-reduced-motion, pauses while off-screen
   Accordions reuse the PDP behaviour: initProductAccordions() runs globally on
   load (live pages); here we only (re)bind on shopify:section:load (editor).
   ========================================================================== */
(function () {
  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class ImageTextSplit extends HTMLElement {
    connectedCallback() {
      this._observers = [];
      this.querySelectorAll('.its__video').forEach((video) => this._setupVideo(video));
    }

    disconnectedCallback() {
      this._observers.forEach((observer) => observer.disconnect());
    }

    _setupVideo(video) {
      const container = video.closest('.its__media-item') || this;
      const toggle = container.querySelector('[data-its-toggle]');
      let userPaused = REDUCED_MOTION;

      const play = () => {
        const attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') {
          attempt.catch(() => {});
        }
      };

      const setState = (playing) => {
        if (!toggle) return;
        toggle.dataset.playing = playing ? 'true' : 'false';
        toggle.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      };

      video.addEventListener('play', () => setState(true));
      video.addEventListener('pause', () => setState(false));

      if (toggle) {
        toggle.addEventListener('click', () => {
          if (video.paused) {
            userPaused = false;
            play();
          } else {
            userPaused = true;
            video.pause();
          }
        });
      }

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                if (!userPaused) play();
              } else {
                video.pause();
              }
            });
          },
          { threshold: 0.15 }
        );
        observer.observe(video);
        this._observers.push(observer);
      } else if (!userPaused) {
        play();
      }

      setState(!video.paused);
    }
  }

  if (!customElements.get('image-text-split')) {
    customElements.define('image-text-split', ImageTextSplit);
  }

  // Theme editor: rebind accordions when this section is re-rendered.
  document.addEventListener('shopify:section:load', (event) => {
    if (typeof window.initProductAccordions === 'function' && event.target.querySelector('.product-accordion-group')) {
      window.initProductAccordions(event.target);
    }
  });
})();
